export function throttle(
    // biome-ignore lint/suspicious/noExplicitAny: biome migration
    func: (...args: any[]) => void,
    wait: number,
    type: 'leading' | 'trailing' | 'both' = 'trailing'
) {
    let timeout: ReturnType<typeof setTimeout>
    let lastCalled = 0

    return (...args: Parameters<typeof func>) => {
        const now = Date.now()
        const remaining = wait - (now - lastCalled)

        clearTimeout(timeout)

        if (remaining <= 0) {
            func(...args)
            lastCalled = now
        } else if (type === 'leading') {
            timeout = setTimeout(() => func(...args), remaining)
        } else if (type === 'trailing') {
            timeout = setTimeout(() => func(...args), wait)
        } else if (type === 'both') {
            if (remaining <= wait / 2) {
                func(...args)
                lastCalled = now
            } else {
                timeout = setTimeout(() => func(...args), wait)
            }
        }
    }
}
